import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import AdminSidebar from '../components/admin/AdminSidebar';
import AdminHeader from '../components/admin/AdminHeader';
import AdminLogin from '../components/admin/AdminLogin';
import DashboardOverview from '../components/admin/DashboardOverview';
import BookingsManagement from '../components/admin/BookingsManagement';
import CustomerDetailsManagement from '../components/admin/CustomerDetailsManagement';
import ContactMessages from '../components/admin/ContactMessages';
import NewsletterManagement from '../components/admin/NewsletterManagement';
import AdventuresManagement from '../components/admin/AdventuresManagement';
import GalleryManagement from '../components/admin/GalleryManagement';
import EnhancedTestimonialsManager from '../components/admin/EnhancedTestimonialsManager';
import FAQManagement from '../components/admin/FAQManagement';
// Enhanced Content Management Components
import WebsiteContentEditor from '../components/admin/WebsiteContentEditor';
import EnhancedAdventuresManagement from '../components/admin/EnhancedAdventuresManagement';
import MediaLibrary from '../components/admin/MediaLibrary';
import ComprehensiveWebsiteEditor from '../components/admin/ComprehensiveWebsiteEditor';
import CalendarManager from '../components/admin/CalendarManager';
// Professional CMS Components
import ProfessionalDashboard from '../components/admin/ProfessionalDashboard';
import ProfessionalAdventuresManager from '../components/admin/ProfessionalAdventuresManager';
import SiteSettings from '../components/admin/SiteSettings';
import MediaCampaignManager from '../components/admin/MediaCampaignManager';
import ApiSettings from '../components/admin/ApiSettings';
import AutoVideoStudio from '../components/admin/AutoVideoStudio';
import FootagePreprocessor from '../components/admin/FootagePreprocessor';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated
    const token = localStorage.getItem('adminToken');
    if (token) {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem('adminToken', token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    setIsAuthenticated(false);
    navigate('/');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <AdminSidebar />
      <div className="flex-1 flex flex-col">
        <AdminHeader onLogout={handleLogout} />
        <main className="flex-1 p-6">
          <Routes>
            <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/dashboard" element={<ProfessionalDashboard />} />
            {/* Content Management */}
            <Route path="/adventures" element={<ProfessionalAdventuresManager />} />
            <Route path="/calendar" element={<CalendarManager />} />
            <Route path="/reviews" element={<EnhancedTestimonialsManager />} />
            <Route path="/gallery" element={<GalleryManagement />} />
            <Route path="/campaigns" element={<MediaCampaignManager />} />
            <Route path="/video-studio" element={<AutoVideoStudio />} />
            <Route path="/footage-preprocessor" element={<FootagePreprocessor />} />
            <Route path="/api-settings" element={<ApiSettings />} />
            <Route path="/faqs" element={<FAQManagement />} />
            {/* Business Operations */}
            <Route path="/bookings" element={<BookingsManagement />} />
            <Route path="/customer-details" element={<CustomerDetailsManagement />} />
            <Route path="/contacts" element={<ContactMessages />} />
            <Route path="/settings" element={<SiteSettings />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;